import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserDetailsDto as UserDto } from '@poker-stats/contracts';

const initialState: {
  user?: UserDto;
} = {};

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loadUser(_state, _action: PayloadAction<number>) {},
    setLoadedUser(state, action) {
      state.user = action.payload;
    },
    recordPayment(
      _state,
      _action: PayloadAction<{
        userId: number;
        amount: number;
        commissionPercent?: number;
        referrerEmail?: string;
        note?: string;
      }>,
    ) {},
  },
});

export const { loadUser, setLoadedUser, recordPayment } = userReducer.actions;
